import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/reset-password.css';

const rawBase = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '');
const API_BASE = rawBase.replace(/\/$/, '');

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const t = (searchParams.get('token') || '').toString();
    setToken(t);
    if (t) {
      const url = `${API_BASE || ''}/api/recover/validate?token=${encodeURIComponent(t)}`;
      fetch(url)
        .then(r => r.json().catch(() => ({})))
        .then(d => {
          if (!d || d.valid !== true) {
            setMessage({ text: (d && d.message) ? d.message : 'Token inválido', type: 'error' });
          }
        })
        .catch(err => {
          console.debug('Token validation error', err);
        });
    } else {
      setMessage({ text: 'Token faltante en la URL', type: 'error' });
    }
  }, [searchParams]);

  function showMessage(text, type = 'success') {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  }

  function validatePasswords(p, c) {
    if (p !== c) {
      showMessage('Las contraseñas no coinciden', 'error');
      return false;
    }
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!regex.test(p)) {
      showMessage('La contraseña debe tener al menos 8 caracteres, incluir mayúsculas, minúsculas y un número', 'error');
      return false;
    }
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validatePasswords(password, confirm)) return;
    if (!token) {
      showMessage('Token ausente', 'error');
      return;
    }
    setLoading(true);
    try {
      const url = `${API_BASE || ''}/api/recover/reset`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        showMessage(data.error || data.message || 'Error al restablecer contraseña', 'error');
        return;
      }
      showMessage('Contraseña restablecida. Redirigiendo al login...', 'success');
      setTimeout(() => navigate('/login'), 1600);
    } catch (err) {
      console.error('Error en /recover/reset', err);
      showMessage('Error de red. Intenta de nuevo.', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="recovery-wrapper">
      <div className="recovery-container">
        <div className="logo-container">
          <a href="/" aria-label="Ir a inicio">
            <img src="/logo512.png" alt="Ker Logo" className="logo-icon" />
          </a>
        </div>

        <h1 className="recovery-title">Restablecer contraseña</h1>
        {message && <div className={`message ${message.type}`}>{message.text}</div>}

        <form onSubmit={handleSubmit} className="form-container active">
          <div className="form-group">
            <label htmlFor="password">Nueva contraseña</label>
            <div className="input-wrapper">
              <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirm">Confirmar contraseña</label>
            <div className="input-wrapper">
              <input id="confirm" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
            </div>
          </div>

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Guardando...' : 'Restablecer contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}